<template>
  <div
    v-if="showLoadingState == true"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productosListado"
  >
    <div class="align-items-baseline display-flex-row">
      <form
        autocomplete="off"
        class="m-form-row m-form-search"
        name="simple-filters-form"
        @submit.prevent="readAcademia"
      >
        <AtomInputPrimary
          v-model="academia_url"
          :disabled="pagination.showLoadingState"
          v-on:keyup.enter="readAcademia"
          name="academiaUrl"
          placeholder="url de la academia"
          type="text"
          wrapperClass="a-input-wrapper-row"
        />
        <AtomSelectPrimary
          v-model.number="filtro.producto_vidroop"
          :disabled="pagination.showLoadingState"
          :elements="selectPrimary.producto_vidroop"
          keyField="id"
          name="tipoProducto"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="readAcademia"
        />
        <AtomSelectPrimary
          v-model.number="filtro.activo"
          :disabled="pagination.showLoadingState"
          :elements="selectPrimary.activo"
          keyField="id"
          name="activo"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="readAcademia"
        />
        <AtomSelectPrimary
          v-model.number="filtro.visible"
          :disabled="pagination.showLoadingState"
          :elements="selectPrimary.visible"
          keyField="id"
          name="visible"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="readAcademia"
        />
        <AtomSelectPrimary
          v-model.number="filtro.pago"
          :disabled="pagination.showLoadingState"
          :elements="selectPrimary.pago"
          keyField="id"
          name="pago"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="readAcademia"
        />
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reset"
          :disabled="pagination.showLoadingState"
          @resetFilter="resetFilter"
        />
      </form>
    </div>
    <div
      class="m-table-primary"
    >
      <table>
        <tr v-show="productos.length">
          <th
            class="text-align-left"
            width="30%"
          >
            NOMBRE
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            ESTADO ACTIVO
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            ESTADO TIENDA
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
            FORMA
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            ACCIONES
          </th>
        </tr>
        <tr
          v-for="producto in productos"
          :key="producto.id"
          class="row-data"
        >
          <td class="text-align-left">
            {{ producto.nombre }}
          </td>
          <td class="text-align-center">
            <AtomTogglePrimary
              v-if="false"
              v-model="producto.activo"
              disabled="true"
              :element-id="producto.id"
              method="updateProductosActivo"
              name="activo"
              sliderClass="a-toggle-slider-billing-primary"
              type="checkbox"
              @updateProductosActivo="updateProductosActivo"
            />
            <span
              v-if="producto.activo"
              class="font-weight-regular text-color-billing-primary"
            >
              Activo
            </span>
            <span
              v-else
              class="font-weight-regular text-color-assets-primary"
            >
              Deshabilitado
            </span>
          </td>
          <td class="text-align-center">
            <AtomTogglePrimary
              v-if="false"
              v-model="producto.visible"
              disabled="true"
              :element-id="producto.id"
              method="updateProductosVisible"
              name="activo"
              sliderClass="a-toggle-slider-billing-primary"
              type="checkbox"
              @updateProductosVisible="updateProductosVisible"
            />
            <span
              v-if="producto.visible"
              class="font-weight-regular text-color-billing-primary"
            >
              Visible
            </span>
            <span
              v-else
              class="font-weight-regular text-color-assets-primary"
            >
              Oculto
            </span>
          </td>
          <td class="text-align-center">
            <span
              v-if="producto.pago"
              class="font-weight-regular"
            >
              Pago
            </span>
            <span
              v-else
              class="font-weight-regular"
            >
              Gratis
            </span>
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.info"
              :element="producto.id"
              @goToProductDetail="goToProductDetail"
            />
            <AtomButtonIconRounded
              :class="!producto.activo ? 'a-disabled-button' : ''"
              :button-icon-rounded="buttonIconRounded.cart"
              :element="producto.id"
              @goToMarketPlace="goToMarketPlace"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import configApp from '@/config'

export default {
  name: 'MoleculeEditionBillingAcademyProducts',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      academia_id: '',
      academia_url: '',
      buttonIconRounded: {
        cart: {
          class: 'a-button-no-border a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom margin-left-xsmall margin-right-xsmall',
          component: '',
          icon: 'far fa-shopping-bag',
          method: 'goToMarketPlace',
          tooltip: 'Acceder',
          type: 'button'
        },
        info: {
          class: 'a-button-no-border a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom margin-left-xsmall margin-right-xsmall',
          component: '',
          icon: 'far fa-file-alt',
          method: 'goToProductDetail',
          tooltip: 'Informacion',
          type: 'button'
        }
      },

      buttonSecondary: {
        reset: {
          class: 'a-button-secondary a-button-billing-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'resetFilter',
          text: '',
          tooltip: this.$t('mEditionBillingAcademyProducts.tooltip.restart'),
          type: 'button'
        }
      },

      filtro: {
        visible: '',
        activo: '',
        pago: '',
        producto_vidroop: '',
        categoria: 0,
        pagina: 1,
        limite: 10
      },

      selectPrimary: {
        activo: [
          {
            id: '',
            name: 'Estado activo'
          },
          {
            id: 0,
            name: 'Deshabilitado'
          },
          {
            id: 1,
            name: 'Activo'
          }
        ],

        pago: [
          {
            id: '',
            name: 'Forma de pago'
          },
          {
            id: 0,
            name: 'Gratis'
          },
          {
            id: 1,
            name: 'Pago'
          }
        ],

        producto_vidroop: [
          {
            id: '',
            name: 'Todos los productos'
          },
          {
            id: 0,
            name: 'Productos sin licencias'
          },
          {
            id: 1,
            name: 'Productos con licencia'
          }
        ],

        visible: [
          {
            id: '',
            name: 'Estado tienda'
          },
          {
            id: 0,
            name: 'Oculto'
          },
          {
            id: 1,
            name: 'Visibles'
          }
        ]
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 1,
        totalQuantity: 0
      },

      productos: {},

      showLoadingState: true
    }
  },

  created () {
    // Verificar si viene una variable por GET, si no usar la configuración por defecto
    this.academia_url = this.$route.query.academia_url || configApp.academyUrl
    this.readAcademia()
  },

  methods: {
    goToMarketPlace (productoId) {
      window.open(`${this.$utils.getMarketPlaceDomain()}/${this.academia_url}/producto/${productoId}/comprar`, '_blank')
    },

    goToProductDetail (productoId) {
      window.open(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.academyProducts.subject')}/${productoId}/${this.$t('mEditionMenu.billing.academyProducts.children.detail.subedition')}`, '_blank')
    },

    readAcademia () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('academia', 'readAcademiaUrl', {}, [this.academia_url])
          .then(response => {
            this.academia_id = response.data.id
            this.readProductos()
          })
          .catch(error => {
            this.showLoadingState = false
            this.pagination.showLoadingState = false
            this.$alerts.pushAlert('mEditionBillingAcademyProducts', 'readAcademy', 'error', 'a-alert-danger')
            console.log(error)
          })
      }
    },

    readProductos () {
      this.$services.read('producto', 'readProductos', {}, [this.academia_id], this.filtro)
        .then(response => {
          this.productos = response.data.productos

          this.pagination.currentQuantity = this.productos.length
          this.pagination.totalPages = response.data.pages
          this.pagination.totalQuantity = response.data.total
          this.pagination.showLoadingState = false

          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    resetFilter () {
      this.academia_url = configApp.academyUrl
      this.filtro = {
        visible: '',
        activo: '',
        pago: '',
        producto_vidroop: '',
        categoria: 0,
        pagina: 1,
        limite: 10
      }
      this.readAcademia()
    },

    setPaginationCurrentPage (page) {
      this.pagination.showLoadingState = true
      this.filtro.pagina = page
      this.pagination.currentPage = page
      this.readProductos()
    }
  }
}

</script>
